import React from 'react';
import SummaryCard from './SummaryCard';

interface SummaryCardsContainerProps {
  summaryCardsData: { title: string, value: any }[],
}

const SummaryCardsContainer: React.FC<SummaryCardsContainerProps> = ({ summaryCardsData }) => {

  if(!summaryCardsData || Object.keys(summaryCardsData).length == 0) return <></>;

  return <div className="summary-cards-v2">
    {
      summaryCardsData.map((data, idx) => <SummaryCard key={idx} {...data} />)
    }
  </div>;
};

export default SummaryCardsContainer;

